import { render, staticRenderFns } from "./bags.vue?vue&type=template&id=bd5f94fa&scoped=true&"
import script from "./bags.vue?vue&type=script&lang=js&"
export * from "./bags.vue?vue&type=script&lang=js&"
import style0 from "./bags.vue?vue&type=style&index=0&id=bd5f94fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5f94fa",
  null
  
)

export default component.exports